import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { REQUEST_SESSION } from "../../store/auth/authActionType";
import { useAuth } from "../../store/auth/reducer";
import { get } from "lodash";

const AuthenticatedRoute: React.FC = () => {
  const dispatch = useDispatch();
  const { busy, user } = useAuth();
  const token = localStorage.getItem("token");
  console.log(user, "ansh");
  console.log("busy----------", busy);
  if (!busy && !get(user, "_id")) {
    dispatch({ type: REQUEST_SESSION });
  }

  if (busy) {
    return <div>loading....</div>;
  }

  if (
    user.role === "ADMIN" ||
    user.role === "SUB_ADMIN" ||
    user.role === "RESTAURANT"
  ) {
    return <Outlet />;
  }
  if (get(user, "_id")) return <Navigate to={{ pathname: "/login" }} />;
  // if (Object.keys(user).length === 0) {
  //   return <Navigate to={{ pathname: "/login" }} />;
  // }
  if (!token) {
    return <Navigate to={{ pathname: "/login" }} />;
  }

  return <div></div>;
};

export default AuthenticatedRoute;

// import React, { useEffect, useState } from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { REQUEST_SESSION } from "../../store/auth/authActionType";
// import { useAuth } from "../../store/auth/reducer";
// import { get } from "lodash";

// const AuthenticatedRoute: React.FC = () => {
//   const dispatch = useDispatch();
//   const { busy, user } = useAuth();
//   const token = localStorage.getItem("token");
//   const [isVerifying, setIsVerifying] = useState(true);

//   useEffect(() => {
//     // If we don't have a user ID and we're not already busy checking
//     if (!get(user, "_id") && !busy && token) {
//       dispatch({ type: REQUEST_SESSION });
//     } else {
//       // Either we have a user or no token, so we're done verifying
//       setIsVerifying(false);
//     }
//   }, [user, busy, token, dispatch]);

//   // When busy changes from true to false, we've completed verification
//   useEffect(() => {
//     if (!busy && isVerifying) {
//       setIsVerifying(false);
//     }
//   }, [busy, isVerifying]);

//   console.log(user, "ansh");
//   console.log("busy----------", busy);
//   console.log("isVerifying----------", isVerifying);

//   // Show loading while we're verifying credentials
//   if (busy || isVerifying) {
//     return <div>loading....</div>;
//   }

//   // No token means not logged in
//   if (!token) {
//     return <Navigate to={{ pathname: "/login" }} />;
//   }

//   // We have a valid user with the right role
//   if (
//     get(user, "_id") &&
//     (user.role === "ADMIN" ||
//       user.role === "SUB_ADMIN" ||
//       user.role === "RESTAURANT")
//   ) {
//     return <Outlet />;
//   }

//   // Token exists but no valid user or wrong role - redirect to login
//   return <Navigate to={{ pathname: "/login" }} />;
// };

// export default AuthenticatedRoute;
